import axios from "axios";
import store from "@/store";
import router from "@/router";
import Qs from "qs";
import {Dialog} from "vant";
import utils from '../libs/utils';
class HttpRequest {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
        this.queue = {};
    }
    getInsideConfig() {
        return {
            baseURL: this.baseUrl,
            timeout: 10e3,
        };
    }

    destroy(url) {
        delete this.queue[url];
    }

    interceptors(instance, url) {
        // 请求拦截
        instance.interceptors.request.use(
            config => {
                let params = {
                    source: process.env.VUE_APP_SOURCE,
                    app:process.env.VUE_APP_ID,
                    gid:process.env.VUE_APP_GID,
                    apph5:process.env.VUE_APP_H5
                }
                if (store.getters.getUserInfo && store.getters.getUserInfo.token) {
                    let { urid, token } = Object.assign(
                      {},
                      store.getters.getUserInfo
                    );
                    params = Object.assign(params, { urid, token });
                    // config.headers.common['Authorization'] = 'Bearer ' + store.getters.getUserInfo.token // 让每个请求携带token--['X-Token']为自定义key 请根据实际情况自行修改
                }
                
                switch (config.method.toUpperCase()) {
                    case 'GET':
                        config.params = { ...params, ...config.params };
                        break;
                    default:
                        config.data = Qs.stringify({ ...params, ...config.data });
                        config.params = { token: params.token };
                        break;
                }
                return config;
            },
            error => {
                return Promise.reject(error);
            }
        );
        // 响应拦截
        instance.interceptors.response.use(
            res => {
                this.destroy(url);
                const {data} = res;
                if (data.status == 200 || data.statusCode == 200) {
                    //!!TODO move 定制
                } else if (data.status == 201 || data.status == 401 || data.message == "urid上传错误") {
                    utils.loginConfirm();
                } else {
                    Dialog.alert({
                        title: "提示",
                        message: data.message
                    })
                }

                return Promise.resolve(data);
            },
            error => {
                let message = error.message;
                if (error.message.indexOf("timeout of") != -1) {
                    message = "请求超时，请刷新页面再试";
                }
                utils.loginConfirm();
                this.destroy(url);
                return Promise.reject(error);
            }
        );
    }

    request(options) {
        const instance = axios.create();
        options = Object.assign(this.getInsideConfig(), options);
        this.interceptors(instance, options.url);
        return instance(options);
    }
}

export default HttpRequest;
